import { Grade, ThemeMap, ThemeMapQuery } from 'common-types'
import ThemeMapGradesMiddleSchool from 'components/core-adoption/builder/ThemeMapGradesMiddleSchool'
import calculateScrollHeight from 'components/core-adoption/functions/calculateScrollHeight'
import SectionTitle from 'components/global/SectionTitle'
import { Col, Row, Section } from 'components/grid'
import { H2 } from 'components/typography/Headings'
import { P } from 'components/typography/Paragraph'
import { CoreAdoptionContext } from 'context/CoreAdoption'
import { graphql, useStaticQuery } from 'gatsby'
import React, { useContext } from 'react'

function addDisabledPropertyToThemes(obj: ThemeMap) {
	const gradesToModify: Array<keyof ThemeMap> = ['grade6', 'grade7', 'grade8']

	gradesToModify.forEach((grade) => {
		const gradeArray = obj[grade] as Grade
		gradeArray.forEach((item, i) => {
			if (grade === 'grade6' && i === 0) return
			else if (grade === 'grade7' && i === 0) return
			else if (grade === 'grade8' && i === 0) return
			// @ts-ignore
			item.disabled = true
		})
	})
	return obj
}

const ThemeMapEnglishMiddleSchool = () => {
	const { account, language } = useContext(CoreAdoptionContext)
	const data = useStaticQuery<ThemeMapQuery>(query).contentfulThemeMap

	const themes = addDisabledPropertyToThemes(data)

	return (
		<Section margin="mt-14" id="recommended-unit-plan-english-middle-school" scrollMarginTop={calculateScrollHeight()}>
			<Row center>
				<Col>
					<div className="mx-auto mb-10 max-w-3xl text-center">
						<H2 className="text-balance mb-1">{language === 'english' ? <span>ARC Core Middle School</span> : 'ARC Core Escuela intermedia'}</H2>
						<span className="mb-2 block text-lg font-semibold italic">
							{language === 'english' ? 'Designed for 45-60 minute literacy blocks' : 'Diseñado para bloques de alfabetización de 45 a 60 minutos'}
						</span>
						<P>
							{language === 'english'
								? 'Students will build knowledge of literary genres, and Science and Social Studies topics through deep research within an intellectual community that reads, writes, thinks, and debates together.'
								: 'Los estudiantes desarrollarán conocimientos sobre géneros literarios y temas de ciencias y estudios sociales a través de una investigación profunda dentro de una comunidad intelectual que lee, escribe, piensa y debate juntos.'}
						</P>
					</div>
				</Col>
			</Row>

			<Row>
				<Col>
					<ThemeMapGradesMiddleSchool data={themes} language="english" grades={account ? account.english_grades_middle_school : []} />
				</Col>
			</Row>
		</Section>
	)
}

const query = graphql`
	query {
		contentfulThemeMap(name: { eq: "Default Middle School (2024)" }) {
			...coreAdoptionThemeMap
		}
	}
`

export default ThemeMapEnglishMiddleSchool
